

export const frontMatter = {};
export const contentTitle = 'LinearInterpolator';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-core-linear-interpolator-md-638.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Constructor",
  "id": "constructor",
  "level": 2
}, {
  "value": "Source",
  "id": "source",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "linearinterpolator",
        children: "LinearInterpolator"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Performs simple linear interpolation between two view states. Implements ", _jsx(_components.a, {
        href: "/docs/api-reference/core/transition-interpolator",
        children: "TransitionInterpolator"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["See ", _jsx(_components.a, {
        href: "/docs/developer-guide/animations-and-transitions#camera-transitions",
        children: "View State Transitions"
      }), " for usage examples."]
    }), "\n", _jsx(_components.h2, {
      id: "constructor",
      children: "Constructor"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {LinearInterpolator} from '@deck.gl/core';\n\nnew LinearInterpolator({transitionProps: ['target', 'zoom']});\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "Parameters:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["options (object)", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "transitionProps"
            }), " (string[], optional) - Array of prop names that should be linearly interpolated. Default ", _jsx(_components.code, {
              children: "['longitude', 'latitude', 'zoom', 'bearing', 'pitch']"
            }), "."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "around"
            }), " (number[2], optional) - A point to zoom/rotate around, ", _jsx(_components.code, {
              children: "[x, y]"
            }), " in screen pixels. If provided, the location at this point will not move during the transition."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "makeViewport"
            }), " (Function, optional) - Called to construct a ", _jsx(_components.a, {
              href: "/docs/api-reference/core/viewport",
              children: "viewport"
            }), ", e.g. ", _jsx(_components.code, {
              children: "props => new WebMercatorViewport(props)"
            }), ". Must be provided if ", _jsx(_components.code, {
              children: "around"
            }), " is used."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "source",
      children: "Source"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://github.com/visgl/deck.gl/tree/9.4-release/modules/core/src/transitions/linear-interpolator.ts",
        children: "modules/core/src/transitions/linear-interpolator.ts"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

